import React, { useState } from 'react';
import Card from '../Card';
import GameEndOverlay from '../animations/GameEndOverlay';
import ShuffleCardsAnimated from '../animations/ShuffleCardsAnimated';
import ChangingTurnAnimated from '../animations/ChangingTurnAnimated';
import DeathAnimated from '../animations/DeathAnimated';
import BuyCardAnimated from '../animations/BuyCardAnimated';
import KeepCardsAnimated from '../animations/KeepCardsAnimated';
import DiceRollResultAnimated from '../animations/DiceRollResultAnimated';
import FlyingBubblesAnimated from '../animations/FlyingBubblesAnimated';

export default function AnimationOverlay(props) {
    const [curAnimationInternalId, setCurAnimationInternalId] = useState(0);
    const curAnimation = props.curAnimation;

    if (curAnimation === null || curAnimation.usesOverlay === false) {
        return null;
    }

    if (curAnimation.iid !== curAnimationInternalId) {
        // Force a DOM change after an animation changed so classes get re-added and animations re-executed
        setTimeout(() => setCurAnimationInternalId(curAnimation.iid), 1);
        return null;
    }

    let content = "";
    if (curAnimation.type === "playing-card-special" || curAnimation.type === "playing-card-normal") {
        content = <Card type={curAnimation.cardType} animating={true} movementType={curAnimation.type} />;
    }
    else if (curAnimation.type === "dice-roll-accepted") {
        content = <DiceRollResultAnimated />;
    }
    else if (curAnimation.type === "applying-keep-cards") {
        content = <KeepCardsAnimated cards={curAnimation.cards} playerName={curAnimation.playerName} />;
    }
    else if (curAnimation.type === "game-end") {
        content = <GameEndOverlay gameResult={curAnimation.gameResult} />;
    }
    else if (curAnimation.type === "shuffle-new-cards") {
        content = <ShuffleCardsAnimated cards={curAnimation.cards} movementType={curAnimation.movementType} />;
    }
    else if (curAnimation.type === "buying-card") {
        content = <BuyCardAnimated cardType={curAnimation.cardType} toPlayerIdx={curAnimation.toPlayerIdx} />
    }
    else if (curAnimation.type === "changing-turn") {
        content = <ChangingTurnAnimated
            monsterId={curAnimation.next_player.monster_id}
            playerName={curAnimation.next_player.name}
            isGameStart={curAnimation.game_start === true}
        />;
    }
    else if (curAnimation.type === "player-death") {
        content = <DeathAnimated deathType={curAnimation.deathType} monsterId={curAnimation.monsterId} />;
    }

    // We'll have effects if there are any events associated with this animation
    let animatedBubbles = "";
    if (curAnimation.events) {
        animatedBubbles = <FlyingBubblesAnimated animationType={curAnimation.type} events={curAnimation.events} />;
    }

    const animationOverlayClass = 'animation-' + curAnimation.type;
    return <div id="animation-overlay" className={`noselect ${animationOverlayClass}`}>
        {content}
        {animatedBubbles}
    </div>;
}
